



















import { Vue, Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import UserTreeView from '@/components/UserTreeView.vue';
import AdminTreeViewForPlotly from '@/components/AdminTreeViewForPlotly.vue';
import MarkersFilteringView from '@/components/MarkersFilteringView.vue';
import CoverageStatsView from '@/components/CoverageStatsView.vue';
import OverLayView from '@/components/OverLayView.vue';
import mapboxgl from 'mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import { ICustomer, IProject, IMarkers } from '@/interfaces/data';
import store from '@/store';
import {
  SET_OVERLAY_DISPLAY,
  COPY_MARKERS_TO_TEMPMARKERS,
  SET_FILTERING_STATE_TO_DEFAULT,
  SET_FILTERING_ELEMENT_DISABLED,
  CHANGE_SLIDER_MODEL_VALUE,
  CHANGE_RADIO_GROUP_TEXT,
  CLEAR_TEMPMARKERS
} from '@/store/constants/mutation-types';

@Component({
  components: {
    AdminTreeViewForPlotly,
    UserTreeView,
    MarkersFilteringView,
    CoverageStatsView,
    OverLayView
  }
})
export default class MapboxView extends Vue {
  public $auth!: {
    token: string;
    isAuthenticated: boolean;
    isAdmin: boolean;
  };

  private treeViewModel = [];
  private treeViewItems = [];
  private treeViewModelCopy = [];

  @(namespace('ProjectModule').State('projects')) private projects!: IProject[];

  @(namespace('CustomerModule').State('customers'))
  private customers!: ICustomer[];

  @(namespace('LocationModule').State('tempMarkers'))
  private tempMarkers!: IMarkers[];

  @(namespace('ProjectModule').Action('getProjects'))
  private getProjects!: (token) => Promise<{}>;

  @(namespace('CustomerModule').Action('getCustomers'))
  private getCustomers!: (token) => Promise<{}>;

  @(namespace('LocationModule').Mutation('deleteLocation'))
  private deleteLocation!: (projectId) => null;

  @(namespace('LocationModule').Mutation(CLEAR_TEMPMARKERS))
  private clearTempMarkers!: () => null;

  private map = null;

  // private coordinates = {
  //   type: 'FeatureColletion',
  //   crs: {
  //     type: 'name',
  //     properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' }
  //   },
  //   features: []
  // };

  private onTreeModelPropertyChanged(items) {
    store.commit(`OverLayModule/${SET_OVERLAY_DISPLAY}`, true);
    // if the tree view item is checked the array length will
    // be bigger than the previous length

    if (this.treeViewModel.length > this.treeViewModelCopy.length) {
      console.log('treeview checked');
      // when the checkbox is checked
      items.map(async item => {
        console.log(this.treeViewModel);
        if (!this.treeViewModelCopy.includes(item)) {
          console.log(item);
          if (item.startsWith('Project')) {
            await store.dispatch(
              'LocationModule/requestAllLocationsForProject',
              {
                token: this.$auth.token,
                projectId: item.slice(8)
              }
            );
            store.commit(`LocationModule/${COPY_MARKERS_TO_TEMPMARKERS}`);
          }
          store.commit(
            `MarkersFilteringModule/${SET_FILTERING_ELEMENT_DISABLED}`,
            false
          );
          store.commit(
            `MarkersFilteringModule/${CHANGE_RADIO_GROUP_TEXT}`,
            'all'
          );

          const coordinates = {
            type: 'FeatureColletion',
            crs: {
              type: 'name',
              properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' }
            },
            features: []
          };

          this.tempMarkers.map(location => {
            coordinates.features.push({
              type: 'Feature',
              properties: {
                coverage: location.coverage,
                margins: location.margins.join(', '),
                coverageStatus: location.coverageStatus
              },
              geometry: {
                type: 'Point',
                coordinates: [location.position.lng, location.position.lat]
              },
              project: item
            });
          });

          this.map.addSource(item, {
            type: 'geojson',
            data: coordinates,
            cluster: true,
            clusterMaxZoom: 4, // Max zoom to cluster points on
            clusterRadius: 1000 // Radius of each cluster when clustering points (defaults to 50)
          });

          this.map.addLayer({
            id: `${item}-clusters`,
            type: 'circle',
            source: item,
            filter: ['has', 'point_count'],
            paint: {
              // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
              // with three steps to implement three types of circles:
              //   * Blue, 20px circles when point count is less than 100
              //   * Yellow, 30px circles when point count is between 100 and 750
              //   * Pink, 40px circles when point count is greater than or equal to 750
              'circle-color': [
                'step',
                ['get', 'point_count'],
                '#51bbd6',
                100,
                '#f1f075',
                750,
                '#f28cb1'
              ],
              'circle-radius': [
                'step',
                ['get', 'point_count'],
                20,
                100,
                30,
                750,
                40
              ]
            }
          });

          this.map.addLayer({
            id: `${item}-cluster-count`,
            type: 'symbol',
            source: item,
            filter: ['has', 'point_count'],
            layout: {
              'text-field': '{point_count_abbreviated}',
              'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
              'text-size': 12
            }
          });

          this.map.addLayer({
            id: `${item}-unclustered-point`,
            type: 'circle',
            source: item,
            filter: ['!', ['has', 'point_count']],
            paint: {
              'circle-color': ['case', ['get', 'coverage'], '#0f0', '#f00'],
              'circle-radius': 6,
              'circle-stroke-width': 1,
              'circle-stroke-color': '#fff'
            }
          });

          this.map.on('click', e => {
            const features = this.map.queryRenderedFeatures(e.point, {
              layers: [`${item}-unclustered-point`]
            });

            if (!features.length) {
              return;
            }

            const feature = features[0];

            const popup = new mapboxgl.Popup({ offset: [0, -15] })
              .setLngLat(feature.geometry.coordinates)
              .setHTML(
                `<p> <b> lat: </b> ${feature.geometry.coordinates[0]} </p>
                 <p> <b> lng: </b> ${feature.geometry.coordinates[1]} </p>
                 <p> <b> covearge status: </b> ${feature.properties.coverageStatus} </p>
                 <p> <b> margins </b> ${feature.properties.margins}  </p>`
              )
              .addTo(this.map);
          });

          store.commit(`OverLayModule/${SET_OVERLAY_DISPLAY}`, false);
        }
      });
    } else {
      this.treeViewModelCopy.map(item => {
        // when the checkbox is unchecked
        console.log('treeview unchecked');
        console.log(this.treeViewModel);
        console.log(items);

        if (!this.treeViewModel.includes(item)) {
          this.deleteLocation(parseInt(item.slice(8), 10));

          this.map.removeLayer(`${item}-clusters`);
          this.map.removeLayer(`${item}-cluster-count`);
          this.map.removeLayer(`${item}-unclustered-point`);
          this.map.removeSource(item);
        }

        if (this.treeViewModel.length === 0) {
          store.commit(
            `MarkersFilteringModule/${SET_FILTERING_ELEMENT_DISABLED}`,
            true
          );
          store.commit(
            `MarkersFilteringModule/${CHANGE_SLIDER_MODEL_VALUE}`,
            0
          );
          store.commit(`MarkersFilteringModule/${CHANGE_RADIO_GROUP_TEXT}`, '');
        }

        store.commit(`OverLayModule/${SET_OVERLAY_DISPLAY}`, false);
      });
    }
    this.treeViewModelCopy = this.treeViewModel.slice();
  }

  private async created() {
    this.map = null;
    this.clearTempMarkers();
    // create load-children
    store.commit(`LocationModule/${CLEAR_TEMPMARKERS}`);
    await this.getCustomers(this.$auth.token);
    await this.getProjects(this.$auth.token);

    this.customers.map(customer => {
      const treeViewItem = {
        id: `Customer ${customer.id}`,
        name: customer.name,
        children: []
      };

      this.projects.map(project => {
        if (project.customerId === customer.id) {
          treeViewItem.children.push({
            id: `Project ${project.id}`,
            name: project.name,
            customerId: customer.id
          });
        }
      });
      this.treeViewItems.push(treeViewItem);
    });
  }

  private mounted() {
    mapboxgl.accessToken = `${process.env.VUE_APP_MAPBOX_ACCESS_TOKEN}`;

    this.map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/outdoors-v10',
      center: [135, -25],
      zoom: 3
    });

    this.map.addControl(new mapboxgl.FullscreenControl(), 'top-left');
    this.map.addControl(new mapboxgl.ScaleControl(), 'bottom-right');

    this.map.addControl(
      new MapboxGeocoder(
        {
          accessToken: mapboxgl.accessToken,
          mapboxgl
        },
        'top-right'
      )
    );
    this.map.addControl(new mapboxgl.NavigationControl());
    this.map.addControl(new mapboxgl.GeolocateControl());

    this.map.on(
      'mouseenter',
      'clusters',
      () => (this.map.getCanvas().style.cursor = 'pointer')
    );
    this.map.on(
      'mouseleave',
      'clusters',
      () => (this.map.getCanvas().style.cursor = '')
    );

    this.map.on('click', 'clusters', e => {
      const features = this.map.queryRenderedFeatures(e.point, {
        layers: ['clusters']
      });
      const clusterId = features[0].properties.cluster_id;
      this.map
        .getSource('xact-markers')
        .getClusterExpansionZoom(clusterId, function(err, zoom) {
          if (err) return;

          this.map.easeTo({
            center: features[0].geometry.coordinates,
            zoom
          });
        });
    });
  }
}
